"use client";
import React, { useContext } from "react";
import styles from "./styles.module.css";
import logo from "../../Assets/images/logo.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { generateYupSchema } from "../../App/Helpers/ValidationSchema/validator.js";
import { UsersApi } from "../../App/api/users.api.js";
import { toast } from "react-toastify";
import LoaderContext from "../loader/LoaderContext.js";

function VerifyOtp({meta}) {
  const navigate = useNavigate();
  const { handleLoading } = useContext(LoaderContext);

  const location = useLocation();
  const { emailOrPhone } = location.state || {};

  const initialValues = {
    otp: "",
  };

  const { handleChange, values, handleSubmit, errors, handleBlur, touched } =
    useFormik({
      initialValues: initialValues,
      validationSchema: generateYupSchema(initialValues),
      onSubmit: async (value) => {
        handleLoading(true);
        const payload = {
          emailOrPhone: emailOrPhone,
          otp: value?.otp?.toString(),
        };

        try {
          const res = await UsersApi.verfiryOtp(payload);
          toast.success("OTP verified successfully");
          handleLoading(false);
          navigate("/reset-password", {
            state: { emailOrPhone: payload?.emailOrPhone },
          });
        } catch (err) {
          // console.log(err);
          toast.error("OTP varification failed");
          handleLoading(false);
        }
      },
    });

  const handleBackToLogin = () => {
    navigate("/");
  };

  return (
    <div className={styles.container}>
      <div className={styles.loginHeader}>
        <p className={styles.heading}>Welcome to eDelivery Admin Panel</p>
      </div>
      <div className={styles.loginForm}>
        <Link className={styles.logo} to="#">
          <img src={logo} alt="logo" width="100px" height="100px"></img>
        </Link>
        <h4 className={styles.formH}>Verify OTP</h4>
        <form onSubmit={handleSubmit} className={styles.Loginform}>
          <div className={styles.inputWrapper}>
            <label className={styles.label} htmlFor="otp">
              OTP
            </label>
            {errors.otp && touched.otp ? (
              <p
                style={{ paddingLeft: "0", paddingBlock: ".875rem" }}
                className="ess-form-error"
              >
                {" "}
                {errors.otp}{" "}
              </p>
            ) : null}
            <input
              className={styles.input}
              id="otp"
              name="otp"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.otp}
              placeholder="Enter 6 digit OTP"
              type="number"
            />
          </div>

          <div className={styles.buttonWrapper}>
            <p className={styles.label} onClick={handleBackToLogin}>
              Login
            </p>
            <button className={styles.button}>Verify OTP</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default VerifyOtp;
